var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCerrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9459 0.684553C19.3843 0.246241 19.9787 0 20.5986 0H46.4014C47.0213 0 47.6157 0.246241 48.0541 0.684553L66.3155 18.9459C66.7538 19.3843 67 19.9787 67 20.5986V46.4014C67 47.0213 66.7538 47.6157 66.3155 48.0541L48.0541 66.3155C47.6157 66.7538 47.0213 67 46.4014 67H20.5986C19.9787 67 19.3843 66.7538 18.9459 66.3155L0.684553 48.0541C0.246241 47.6157 0 47.0213 0 46.4014V20.5986C0 19.9787 0.246241 19.3843 0.684553 18.9459L18.9459 0.684553ZM21.5667 4.67442L4.67442 21.5667V45.4333L21.5667 62.3256H45.4333L62.3256 45.4333V21.5667L45.4333 4.67442H21.5667ZM22.4985 22.4985C23.4112 21.5857 24.891 21.5857 25.8038 22.4985L33.5 30.1946L41.1961 22.4985C42.1089 21.5857 43.5887 21.5857 44.5014 22.4985C45.4142 23.4112 45.4142 24.891 44.5014 25.8038L36.8053 33.5L44.5014 41.1961C45.4142 42.1089 45.4142 43.5887 44.5014 44.5014C43.5887 45.4142 42.1089 45.4142 41.1961 44.5014L33.5 36.8053L25.8038 44.5014C24.891 45.4142 23.4112 45.4142 22.4985 44.5014C21.5857 43.5887 21.5857 42.1089 22.4985 41.1961L30.1946 33.5L22.4985 25.8038C21.5857 24.891 21.5857 23.4112 22.4985 22.4985Z",
    fill: "#F2F5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrorIcon);
export default __webpack_public_path__ + "static/media/cerror-icon.b018dda435394a12b359edc3a9d8481c.svg";
export { ForwardRef as ReactComponent };